
import React, { useEffect, useState } from 'react';
import { Card, Divider, Button, Backdrop, CircularProgress } from '@mui/material';
import Modal from 'react-bootstrap/Modal';
import services from '../../services';
import { toast } from 'react-toastify';
import AddClient from './AddClient';
import AddUser from './AddUser';
import axios from 'axios';
import { FiEdit, FiLink } from "react-icons/fi";
import { GoUnlink } from "react-icons/go";
import { Tooltip } from 'react-tooltip';
import { GrSync } from "react-icons/gr";
import Resync from "./Re-syncAccount";
import UnlinkConfirmation from './UnlinkConfirmation';
const WhatsappAuth = ({ emailStatus, onClose }) => {
    const [allClient, setAllClient] = useState([]);
    const [authUrl, setAuthUrl] = useState('');
    const [step, setStep] = useState(1);
    const [authEmail, setAuthEmail] = useState('');
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [clientId, setClientId] = useState(null);
    useEffect(() => {
        getClientEmail();
    }, []);
    const getClientEmail = async () => {
        setIsLoading(true);
        try {
            const { data } = await services.email.GET_ALL_CLIENT();
            setAllClient(data || []);
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        checkEmailUser();
    }, []);

    const [clientData, setClientData] = useState([]);
    const checkEmailUser = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/token/`, {
                headers: {
                    Authorization: `Bearer ${localStorage?.getItem('access_token')}`,
                },
            });

            setClientData(response?.data?.data);
            const findUnAuth = response?.data?.data?.find(({ token_status }) => token_status == 'token is authorized');
            if (findUnAuth?.client_id) {
                updateAuthEmail(findUnAuth?.client_id);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const updateAuthEmail = async (client_id) => {
        try {
            const response =
                services.email.updateAuthEmail(client_id);
            setAuthUrl(response?.data?.authUrl);
        } catch (error) {
            console.error(error);
        }
    };

    const [authUrlData, setAuthUrlData] = useState([])
    const getAllAuthCredentials = async () => {
        try {
            const response = await services.email.GET_ALL_CREDENTIALS_EMAIL();
            setAuthUrlData(response?.data?.data)
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        getAllAuthCredentials()
    }, [])

    const handleStepChange = async (newStep, account = null) => {
        setIsLoading(true);
        try {
            if (newStep === 3 || newStep === 5) {
                await getAllAuthCredentials();
            }
            if (account) {
                setSelectedAccount(account);
                setAuthEmail(account.email);
            }
            setStep(newStep);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    function formatTimestampToDate(timestamp) {
        if (!timestamp || isNaN(Number(timestamp))) return "-";
        const date = new Date(Number(timestamp));
        const formatted = date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
        return formatted.replace(/am|pm/, (match) => match.toUpperCase());
    }

    const handleUpdateSyncmailStatus = async (item) => {
        setIsLoading(true);
        try {
            item.isMailSend = !item.isMailSend;
            const response = await services.email.UPDATE_EMAIL_SENDMAIL(item?.id, { isMailSend: item?.isMailSend })
            toast.success("Sync mail status updated successfully")
            await getClientEmail()
        } catch (error) {
            console.error(error)
            toast.error("Something went wrong")
        } finally {
            setIsLoading(false);
        }
    }
    const handleYes = () => {
        window.open(
            "https://myaccount.google.com/connections?gar=WzJd&continue=https%3A%2F%2Fmyaccount.google.com%2Fsecurity%3Fgar%3DWzJd%26hl%3Den_GB%26utm_source%3DOGB%26utm_medium%3Dact&hl=en_GB&utm_source=OGB&utm_medium=act",
            "_blank",
            "noopener,noreferrer"
        );
    }
    return (
        <>
            {step === 1 && (
                <Modal show={emailStatus} onHide={onClose} centered size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', padding: '10px' }}>
                                <div>Synced Gmail Accounts List</div>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Divider />
                    <Modal.Body style={{ maxHeight: '500px', overflow: 'auto' }}>
                        {allClient && allClient.length > 0 ? (
                            <div className="py-2">
                                <table className="min-w-full bg-white border border-solid border-gray-200 rounded-xl shadow-md overflow-hidden">
                                    <thead>
                                        <tr className="bg-gray-50  border-b-2 border-gray-200">
                                            <th className="px-2 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">No.</th>
                                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Name</th>
                                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Email</th>
                                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Created</th>
                                            <th className="px-3 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Last Updated</th>
                                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Expire Date</th>
                                            <th className="px-1 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">is For Send Mail</th>
                                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {allClient.map((item, index) => (
                                            <tr key={item.id} className={item?.expiration < Date.now() ? 'bg-red-200' : 'bg-white'}>
                                                <td className="px-2 py-3 whitespace-nowrap text-sm text-gray-900 ">{index + 1}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-900 ">{item?.name || '-'}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-900">{item?.email}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-900">{item?.createdAt ? new Date(item.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '-'}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-900">{item?.updatedAt ? new Date(item.updatedAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '-'}</td>
                                                <td className="px-1 py-3 whitespace-nowrap text-sm text-gray-900">  {item?.expiration ? formatTimestampToDate(item.expiration) : '-'}</td>
                                                <td className="px-5 py-2">
                                                    <div className="form-check form-switch flex items-center">
                                                        <input
                                                            className="form-check-input h-5 w-9 rounded-full border-gray-300 bg-gray-200 checked:bg-blue-500 focus:ring-blue-400"
                                                            type="checkbox"
                                                            checked={item.isMailSend}
                                                            onChange={() => handleUpdateSyncmailStatus(item)}
                                                        />
                                                    </div>
                                                </td>
                                                <td className="px-2 py-3 whitespace-nowrap text-sm flex gap-2 text-gray-900">
                                                    <button className="table-icon-edit" data-tooltip-id='my-tooltip' data-tooltip-content="Sync Account" onClick={() => { setClientId(item?.client_id), setStep(3) }} >
                                                        <FiLink />
                                                    </button>
                                                    <button className="table-icon-remove" data-tooltip-id='my-tooltip' data-tooltip-content="Unlink Account" onClick={() => {
                                                        handleStepChange(5, item);
                                                    }}>
                                                        <GoUnlink />
                                                    </button>
                                                    {item?.expiration >= Date.now() && (
                                                        <button
                                                            className="table-icon-remove !bg-[#BDE8F5]"
                                                            data-tooltip-id="my-tooltip"
                                                            data-tooltip-content="Sync Old Mail"
                                                            onClick={() => {
                                                                handleStepChange(4, item);
                                                            }}
                                                        >
                                                            <GrSync />
                                                        </button>
                                                    )}
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-center text-gray-500 py-8">No Client</div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="contained"
                            onClick={() => handleStepChange(2)}
                            sx={{
                                fontSize: "small",
                                width: "125px",
                                textTransform: 'none'
                            }}
                        >
                            View
                        </Button>
                        <Button
                            variant="contained"
                            className='text-nowrap'
                            onClick={() => handleStepChange(3)}
                            style={{
                                marginLeft: '10px',
                                fontSize: "small",
                                width: "125px",
                                textTransform: 'none'
                            }}
                        >
                            Sync New Gmail
                        </Button>
                    </Modal.Footer>
                </Modal >
            )}
            {step === 2 && (
                <AddClient
                    show={true}
                    onHide={() => setStep(1)}
                    setAuthUrl={setAuthUrl}
                    setStep={setStep}
                    authUrlData={authUrlData}
                    setIsLoading={setIsLoading}
                />
            )}
            {step === 3 && (
                <AddUser show={true} onHide={() => setStep(1)} authUrl={authUrl} setStep={setStep} updateAuthEmail={updateAuthEmail} setAuthUrlData={setAuthUrlData} authUrlData={authUrlData} setIsLoading={setIsLoading} clientId={clientId} />
            )}
            {step === 4 && (
                <Resync show={true} onHide={() => setStep(1)} authEmail={authEmail} setStep={setStep} updateAuthEmail={updateAuthEmail} setAuthUrlData={setAuthUrlData} authUrlData={authUrlData} setIsLoading={setIsLoading} />
            )}
            {step === 5 && (
                <UnlinkConfirmation
                    show={true}
                    onHide={() => {
                        setStep(1)
                        setSelectedAccount(null);
                    }}
                    handleYes={() => { handleYes() }}
                    authUrlData={authUrlData}
                    accountInfo={selectedAccount}
                    setIsLoading={setIsLoading}
                />
            )}
            <Tooltip id="my-tooltip" place='top' style={{ zIndex: 9999 }} />
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.modal + 1 })}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
};

export default WhatsappAuth;
